import * as Sentry from '@sentry/solid'
import { Component } from 'solid-js'
import { render, hydrate } from 'solid-js/web'
import App from './App'
import { characterStore } from './store'

Sentry.init({
  dsn: 'https://c56fc47ad6cc438445806eca0c6c33d0@o4508736610041856.ingest.us.sentry.io/4508736611549184',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/(.*)cosplayfans\.ai\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const AppContainer: Component = () => <App />

// Check for SSR-provided data and populate store BEFORE rendering
const initialData = (window as any).__INITIAL_DATA__

if (initialData && initialData.characters) {
  try {
    // Pre-populate store with SSR data synchronously before rendering
    // IMPORTANT: loaded must be a timestamp (number), not a boolean
    const timestamp = Date.now()
    const characters = initialData.characters
    const map = characters.reduce((acc: any, char: any) => {
      acc[char._id] = char
      return acc
    }, {})

    characterStore.setState({
      characters: {
        list: characters,
        map: map,
        loaded: timestamp,
      },
    })
  } catch (error) {
    // Silently fail - SSR data population is optional
  }
}

// Always use render() since we're not doing component-level SSR
// (we only pre-render the HTML shell with meta tags for SEO)
render(() => <AppContainer />, document.getElementById('root') as HTMLElement)
